import { AddBoxOutlined, IndeterminateCheckBoxOutlined as IndeterminateCheckBoxIcon} from '@mui/icons-material';
import AppContext, { AppContextProps } from 'containers/context/Context';
import { IconButton, Typography, Box, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { useEffect, useContext , useState} from "react";
import useNav from 'components/RouteService/useNav';
import TreeView from '@mui/lab/TreeView';
import TreeItem,{treeItemClasses} from '@mui/lab/TreeItem';
import {
    useMenuOption,
    SubContainerX,
    FloatButton,
    EmptyState,
    ColumnFlex,
    Container,
    SearchBar,
    MenuItem,
    Menu,
    RowFlex,
} from "@ifca-ui/core";
import {
    ExpandMore,
    ExpandLess,
    Add,
    AddCircle,
    MoreVert,
} from "@mui/icons-material";
import FormDialog from './Form/FormDialog';
import DetailFormDialog from './Form/DetailFormDialog';
import { DeleteDialog } from './Form/DeleteDialog';
import { useGetCompanyCommissionTeamListingLazyQuery } from 'generated/graphql';
import { useFuseSearch } from 'helpers/Hooks/useSearch';
import moment from 'moment';
import { TopSectionHeader } from 'components/Header/HeaderSection';
import {TreeNode} from './TreeNode'
import useACL from 'helpers/Hooks/useACL';
import { baseSalesCommissionPath } from '../SalesComissionSubMenu';
import { useParams } from 'react-router';

type DetailDialogForm = {show: boolean, mode: 'New' | 'Edit', data: any }

const CompanyCommissionTeamStructure = ()=> {
  const { rootState, rootDispatch } = useContext<AppContextProps>(AppContext);
  const { navTo} = useNav();
  const { projectID } = useParams();
  const [formDialog, setFormDialog] = useState(false);
  const [detailFormDialog, setDetailFormDialog] = useState<DetailDialogForm>({show: false, mode: 'New', data: null});
  const [deleteDialog, setDeleteDialog] = useState({show: false, deletedId: null });
  
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  
  const { filteredList, handleSearch, setOriginalListing } =
    useFuseSearch();
  // const [filteredList, setFilteredList] = useState([]);
  // const [originalList, setOriginalList] = useState([]);
  const [treeExpanded, setTreeExpanded] = useState([]);
  const { ACLGuard, Permission } = useACL()
  const acl = Permission.SalesCommission.CompanyCommissionTeamStructure;

  const {
      anchorEl,
      menu,
      handleClick,
      handleClose
  } = useMenuOption();
  const parentData = filteredList.find((item) => item.id === menu?.data?.companyCommissionTeamId)

  const [getCompanyCommissionTeamListing] = useGetCompanyCommissionTeamListingLazyQuery({onCompleted(data) {
    if(!data.getCompanyCommissionTeamListing) return;
    const companyCommissionTeamListingTest = 
      data.getCompanyCommissionTeamListing.map(cct => ({...cct, generateDateSearch: moment(cct.generateDate).format("D MMMM YYYY")}))
    
    setOriginalListing(companyCommissionTeamListingTest)
  }})

  
  useEffect(() => {
    rootDispatch({
      type: 'headerComponent',
      payload: {
        ...rootState.headerComponent,
        leftIcon: {
          icon: 'back',
          props: {
            onClick: () => {
              navTo(`${baseSalesCommissionPath}/${projectID}`)
            },
          },
        },
        rightIcon: {},
        topSection: {
          smTitle: TopSectionHeader,
          title: `${localStorage.getItem('projectName')}`,
        },
        bottomSection: {
          breadcrumbs: {
            current: 'Company Commission Team Structure',
            maxItems: 2,
          },
          rightText: '',
        },
      },
    })

    getCompanyCommissionTeamListing()
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 400);
    
    return () => clearTimeout(timer);
  }, [search]);

  // useEffect(() => {
  //   if (!debouncedSearch) {
  //     setFilteredList(originalList); // Reset to full list if search is empty
  //     return;
  //   }
  
  //   const lowerSearch = debouncedSearch.toLowerCase();
  
  //   const filteredData = originalList.reduce((acc, team) => {
  //     const isDateMatch = team.generateDateSearch.toLowerCase().includes(lowerSearch);
  
  //     // If date matches, keep the entire team as is (all headers & subheaders)
  //     if (isDateMatch) {
  //       acc.push(team);
  //       return acc;
  //     }
  
  //     const filteredHeaders = team.headers.reduce((headerAcc, header) => {
  //       // Filter subheaders
  //       const filteredSubheaders = header.subheaders.filter(subheader =>
  //         (subheader.position?.position.toLowerCase().includes(lowerSearch) ?? false) ||
  //         (subheader.agency?.name.toLowerCase().includes(lowerSearch) ?? false)
  //       );
  
  //       // Check if header itself matches
  //       const isHeaderMatch =
  //         (header.position?.position.toLowerCase().includes(lowerSearch) ?? false) ||
  //         (header.agency?.name.toLowerCase().includes(lowerSearch) ?? false);
  
  //       // If header matches, keep it with ALL subheaders
  //       if (isHeaderMatch) {
  //         headerAcc.push({ ...header, subheaders: header.subheaders });
  //         return headerAcc;
  //       }
  
  //       // If only subheaders match, keep only the matching ones
  //       if (filteredSubheaders.length > 0) {
  //         headerAcc.push({ ...header, subheaders: filteredSubheaders });
  //       }
  
  //       return headerAcc;
  //     }, []);
  
  //     // Only add the team if it has matching headers
  //     if (filteredHeaders.length > 0) {
  //       acc.push({ ...team, headers: filteredHeaders });
  //     }
  
  //     return acc;
  //   }, []);
  
  //   setFilteredList(filteredData);
  // }, [debouncedSearch, originalList]);

  const handleAccordionChange =
  (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded((prev) => {
      if (!newExpanded) {
        const { [panel]: _, ...rest } = prev; // Remove the key if newExpanded is false
        return rest;
      }
      return { ...prev, [panel]: newExpanded };
    });
  };

  const handleToggle = (_, nodeIds) => {
    setTreeExpanded(nodeIds);
  };

  return (
    <>
      <SubContainerX>
        <SearchBar
          title={
            <Typography
              component="span"
              className="text-mdLabel"
              variant="inherit"
            >
              {`Company Commission Team Structure Listing`} (
              <Typography
                component="span"
                variant="inherit"
                className="text-mdLabel search-bar-count-f"
              >
                {filteredList?.length}
              </Typography>
              )
            </Typography>
          }
          searchInput={{
            value: search,
            onChange: e => {
              setSearch(e.target.value)
              handleSearch(e.target.value, ['generateDateSearch'])
            },
            onChangeClearInput: () => {
              setSearch('')
              handleSearch('', ['generateDateSearch'])
            },
          }}
        />
      </SubContainerX>
      <Container>
        <ColumnFlex>
          {filteredList.length === 0 ? 
            (<EmptyState title="No Record found" />) :
            (filteredList.map((team, index) => (
              <Box sx={{marginBottom: '4px'}} key={team.id}>
                <Accordion
                  key={team.id}
                  expanded={Boolean(expanded[team.id])}
                  onChange={handleAccordionChange(`${team.id}`)}
                  disableGutters
                >
                  <AccordionSummary
                    sx={{ 
                      backgroundColor: !!expanded[team.id] ? '#ffe7ba' : '',
                    }}
                    aria-controls={`panel${team.id + 1}-content`}
                    id={`panel${team.id + 1}-header`}
                  >
                    <RowFlex crossAxisAlignment='center' fullWidth>
                      <Box display='flex' flexDirection='column' flexGrow={1}>
                        <RowFlex crossAxisAlignment='center' gap='8px'>
                          <Typography className='text-xsTitle'>{moment(team.generateDate).format("D MMMM YYYY")}</Typography>
                          {!!expanded[team.id] && (
                            <ACLGuard acl={acl.ADD_TEAM}>
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation()
                                  setDetailFormDialog({show: true, mode: 'New', data: {...team, isSub: false},})
                                }} 
                                size='small'
                                sx={{padding: 0}}
                                >
                                  <AddCircle color='primary'/>
                              </IconButton>
                            </ACLGuard>
                          )}
                        </RowFlex>
                        {!expanded[team.id] && (
                          <Typography className="text-desc">
                            <span className="text-label highlight-text">{team.details.length}</span>
                            &nbsp;Records
                          </Typography>
                        )}
                      </Box>
                      <IconButton size='small'>
                        {!!expanded[team.id] ? <ExpandLess/> : <ExpandMore/>}
                      </IconButton>
                    </RowFlex>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      overflowX: 'auto',
                      scrollbarWidth: 'none', 
                      '&::-webkit-scrollbar': {
                        display: 'none'
                      }
                    }}
                  >
                    {team.details?.length === 0 ? (
                      <EmptyState title="No Record found" />
                    ) : (
                      <Box display="flex" flexDirection="column" gap="8px">
                        <TreeView
                          aria-label="multi-level tree"
                          onNodeToggle={handleToggle}
                          expanded={treeExpanded}
                          sx={{
                            background: "white",
                            marginTop: 0,
                            position: "relative",
                            padding: "16px",
                            borderRadius: "4px",
                            boxShadow: `
                              0 3px 1px -2px rgba(0, 0, 0, 0),
                              0 1px 10px 2px rgba(0, 0, 0, 0.05),
                              0 0px 5px 0 rgba(0, 0, 0, 0.1)
                            `,
                            minWidth: 'max-content',
                            [`& .${treeItemClasses.group}`]: {
                              marginLeft: "14.5px",
                              paddingLeft: "12px",
                              borderLeft: "1px dashed black",
                            },
                            [`& .${treeItemClasses.content}`]: { marginBottom: "0px" },
                            [`& .${treeItemClasses.label}`]: { paddingLeft: "8px" },
                            [`& .${treeItemClasses.selected}`]: {
                              backgroundColor: "white !important",
                            },
                          }}
                        >
                          {team.details.map((detail: any, index: number) => (
                            <TreeNode 
                              key={detail.id} 
                              index={index}
                              node={detail}
                              generateDate={team?.generateDate} 
                              treeExpanded={treeExpanded} 
                              handleClick={handleClick}
                              />
                          ))}
                        </TreeView>
                      </Box>
                    )}
                  </AccordionDetails>
                </Accordion>
              </Box>
            )))
          }
        </ColumnFlex>
      </Container>

      <ACLGuard acl={acl.ADD}>
        <FloatButton color='primary' onClick={()=>{setFormDialog(true)}}>
          <Add />
        </FloatButton>
      </ACLGuard>

      {formDialog &&
        <FormDialog
          onCompleted={()=>{
            getCompanyCommissionTeamListing()
            setFormDialog(false)
          }}
          show={formDialog}
          onClose={()=>setFormDialog(false)}
        />
      }
      {detailFormDialog.show &&
        <DetailFormDialog
          show={detailFormDialog.show}
          mode={detailFormDialog.mode}
          data={detailFormDialog.data}
          onClose={()=> setDetailFormDialog((dfg => ({...dfg, show: false, data: null})))}
          onCompleted={()=> {
            getCompanyCommissionTeamListing()
            setDetailFormDialog((dfg => ({...dfg, show: false, data: null})))
          }}
        />
      }
      {deleteDialog.show &&
        <DeleteDialog
          show={deleteDialog.show}
          deletedId={deleteDialog.deletedId}
          onClose={()=> setDeleteDialog({show: false, deletedId: null })}
          onCompleted={()=>{
            getCompanyCommissionTeamListing()
            setDeleteDialog({show: false, deletedId: null })
          }}
        />
      }
      <Menu
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <ACLGuard acl={acl.ADD_SUB}>
          <MenuItem 
            onClick={()=>{
              setDetailFormDialog({
                show: true,  
                mode: 'New', 
                data: {...menu?.data, isSub: true, parentData},
              })
            }}
            disabled={menu?.data?.isUsed}
          >
            Add Sub
          </MenuItem>
        </ACLGuard>
        <ACLGuard acl={acl.UPDATE_SUB}>
          <MenuItem 
            onClick={()=>{
              setDetailFormDialog({
                show: true,  
                mode: 'Edit', 
                data: {...menu?.data, parentData},
              })
            }}
            disabled={menu?.data?.isUsed}
          >
            Edit
          </MenuItem>
        </ACLGuard>
        <ACLGuard acl={acl.DELETE_SUB}>
          <MenuItem 
            onClick={()=>{
              setDeleteDialog({
                show: true,
                deletedId: menu?.id,
              })
            }}
            disabled={menu?.data?.isUsed}
          >
            Delete
          </MenuItem>
        </ACLGuard>
      </Menu>
      </>
  )
}

export default CompanyCommissionTeamStructure;